import http from '../utils/http';

/**
 * 请求地址
 * http://10.200.140.52:6066/ckips
 *
 * @param {obj} params
 * @returns Promise
 */

//下载模板
export function downloadExcel(params) {
    return http.post('/store/downloadExcel', params, {
        needLogin:false
    })
}
//上传模板
export function uploadExcelDevice(params) {
    return http.post('/store/uploadExcelDevice', params, {
        showLoading:true,
    })
}

//确认上传
export function uploadExcelDeviceSure(params) {
    return http.post('/store/uploadExcelDeviceSure', params, {
        showLoading:true,
    })
}
